export default {
  on: {
    pageInit() {
      this.initialize();
    }
  },
  data() {
    var customer_list_height = (this.$f7.theme == 'ios') ? 98 : 107;
    var order_list_height = (this.$f7.theme == 'ios') ? 98 : 107;

    return {
      search_auth_num: '',
      search_mobile: '',
      in_progress: false,
      search_method: 'P',  /* A-승인번호, P-전화번호 */

      barcode: '',
      list_customer: [],
      list_goods: [],
      list_order: [],
      current_user: {},
      customer_list_height: customer_list_height,
      order_list_height: order_list_height,
      payment_amount: 0,
      vlData: {}
    }
  },
  methods: {
    formatNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    /**
     * 초기화
     */
    initialize() {
      this.search_auth_num = '';
      this.search_mobile = '';
      this.in_progress = false;

      this.barcode = '';
      this.payment_amount = 0;
      this.current_user = {};

      if (this.list_customer.length > 0) {
        this.list_customer.splice(0, this.list_customer.length);
      }
      if (this.list_goods.length > 0) {
        this.list_goods.splice(0, this.list_goods.length);
      }
      if (this.list_order.length > 0) {
        this.list_order.splice(0, this.list_order.length);
      }
    },

    /**
     * 검색 초기화
     */
    clearSearchText() {
      this.search_auth_num = '';
      this.search_mobile = '';
      try {
        this.$f7.dialog.close();
      } catch(e) {
        console.log('clearSearchText() - ' + e.message);
      }
    },

    /**
     * 고객검색
     */
    // 승인번호 입력
    onKeyUpSearchAuthNum(event) {
      if (this.in_progress) {
        return;
      }

      var value = event.target.value.toString();
      if (event.which == 13  ||  event.keyCode == 13) {
        if (value.length < 5) {
          this.$f7.dialog.alert('승인번호를 정확히 입력해 주세요.', '판매관리');
          return;
        }
      }

      if (event.which == 13  ||  event.keyCode == 13  ||  value.length >= 5) {
        this.$f7.input.blur(event.target);
        this.search_method = 'A';
        this.searchCustomer(value);
      }
    },
    // 전화번호 입력
    onKeyUpSearchMobile(event) {
      if (this.in_progress) {
        return;
      }

      var value = event.target.value.toString();
      var value = event.target.value.toString();
      if (event.which == 13  ||  event.keyCode == 13) {
        if (value.length < 4) {
          this.$f7.dialog.alert('전화번호를 정확히 입력해 주세요.', '판매관리');
          return;
        }
      }

      if (event.which == 13  ||  event.keyCode == 13  ||  value.length >= 4) {
        this.$f7.input.blur(event.target);
        this.search_method = 'P';
        this.searchCustomer(value);
      }
    },
    // 고객검색 - 승인번호, 전화번호
    searchCustomer(value) {
      if (this.in_progress) {
        return;
      }

      // 관광지아이디 체크
      var tourist_id = localStorage.tourist_id;
      if (tourist_id == undefined  ||  tourist_id == null  ||  tourist_id == '') {
        var msg = (this.$root.$data.group_code == 'A')  ?  '환경설정에서 관광지를 설정해 주세요.'  :  '로그인 후 시도해 주세요.';
        this.$f7.dialog.alert(msg, '판매관리');
        return;
      }

      // 초기화
      this.initialize();

      this.in_progress = true;

      var _this = this;
      var url = (value.length <= 4) ? 'inquiry_phone_number' : 'inquiry_auth_num';

      var formdata = new FormData();
      formdata.set('tourist_id', localStorage.tourist_id);
      formdata.set('query', value);

      _this.$f7.dialog.preloader('잠시만 기다려주세요.<br>');
      _this.$http.post(_this.$api_base_uri + '/' + url, formdata, {
        timeout: 30000
      })
      .then(function (response) {
        console.log(response.data);

        _this.in_progress = false;
        _this.$f7.dialog.close();

        if (response.data.result) {
          // 고객검색결과 저장용 배열 초기화
          if (_this.list_customer.length > 0) {
            _this.list_customer.splice(0, _this.list_customer.length);
          }
          console.log(response);

          // 고객검색결과 처리
          var cnt_list = response.data.list.length;
          for (var i = 0; i < cnt_list; i++) {
            // 고객정보
            var info_user = response.data.list[i].user_name + ' ' + response.data.list[i].user_mobile;
            var info_people = '성인: ' + response.data.list[i].cnt_adult + '명, 청소년: ' + response.data.list[i].cnt_youth + '명, 소인: ' + response.data.list[i].cnt_child + '명';

            _this.list_customer.push({
              barcode: response.data.list[i].barcode,
              info_user: info_user,
              info_people: info_people,
              package_id: response.data.list[i].package_id,
              package_name: response.data.list[i].package_name,

              user_name: response.data.list[i].user_name,
              user_mobile: response.data.list[i].user_mobile,
              cnt_adult: response.data.list[i].cnt_adult,
              cnt_youth: response.data.list[i].cnt_youth,
              cnt_child: response.data.list[i].cnt_child,
              pay_type: response.data.list[i].pay_type
            });
          } // end of for

          console.log(_this.list_customer);

          // 승인번호 조회 - 상품선택 POPUP 표시
          if (_this.search_method == 'A') {
            // 고객선택
            _this.onSelectUser(_this.list_customer[0]);

            // 이용승인 POPUP 표시
            _this.$f7.popup.get('#popup_order_goods').open();

          // 전화번호 검색 - 검색결과 POPUP 표시
          } else {
            _this.$f7.popup.get('#popup_search_customer').open();
            //_this.$f7.virtualList.get('#list_customer').update();
          }
        } else {
          _this.$f7.dialog.alert(response.data.msg, '판매관리');
        }
      })
      .catch(function(error) {
        console.log(error);
        _this.in_progress = false;
        _this.$f7.dialog.close();
        _this.$f7.dialog.alert('고객검색 중 오류가 발생했습니다.<br>' + error, '승인취소');
      });
    },
    renderExternal(vl, vlData) {
      this.vlData = vlData;
    },

    /**
     * 고객선택
     */
    onSelectUser(info) {
      // 선택한 고객정보 저장
      this.current_user.user_name    = info.user_name;
      this.current_user.user_mobile  = info.user_mobile;
      this.current_user.package_id   = info.package_id;
      this.current_user.package_name = info.package_name;
      this.current_user.cnt_adult    = Number(info.cnt_adult);
      this.current_user.cnt_youth    = Number(info.cnt_youth);
      this.current_user.cnt_child    = Number(info.cnt_child);
      this.current_user.barcode      = info.barcode;
      this.current_user.pay_type     = info.pay_type;

      console.log(this.current_user);

      // 검색 초기화
      this.search_auth_num = '';
      this.search_mobile = '';

      // 이용가능 상품목록
      this.getGoodsList();

      // 고객선택 닫기
      this.$f7.popup.get('#popup_search_customer').close();

      // 승인화면 열기
      this.$f7.popup.get('#popup_order_goods').open();
    },

    /**
     * 이용가능 상품목록 가져오기
     */
    getGoodsList() {
      var _this = this;

      var formdata = new FormData();
      formdata.set('tourist_id', localStorage.tourist_id);
      formdata.set('barcode', this.current_user.barcode);
      formdata.set('goods_store_yn', localStorage.goods_store_yn);

      _this.$f7.dialog.preloader('잠시만 기다려주세요.<br>');
      _this.$http.post(_this.$api_base_uri + '/get_goods_list', formdata, {
        timeout: 30000
      })
      .then(function(response) {
        if (response.data.result) {
          // 배열 초기화
          if (_this.list_goods.length > 0) {
            _this.list_goods.splice(0, _this.list_goods.length);
          }

          // 상품목록
          var cnt_list = response.data.list_goods.length;
          for (var i = 0; i < cnt_list; i++) {
            var goods_name = (response.data.list_goods[i].goods_nickname == '')  ?  response.data.list_goods[i].goods_name  :  response.data.list_goods[i].goods_nickname;

            _this.list_goods.push({
              goods_id   : response.data.list_goods[i].goods_id,
              goods_name : goods_name,
              adult_price: (_this.current_user.pay_type == 'PR'  ?  0  :  Number(response.data.list_goods[i].sale_adult_price)),
              youth_price: (_this.current_user.pay_type == 'PR'  ?  0  :  Number(response.data.list_goods[i].sale_youth_price)),
              child_price: (_this.current_user.pay_type == 'PR'  ?  0  :  Number(response.data.list_goods[i].sale_child_price))
            });
          }

          // 이용상품 목록에 상품 자동추가
          if (cnt_list > 0) {
            // 에코랜드일 경우
            if (localStorage.tourist_id == '110') {
              for (var i = 0; i < cnt_list; i++) {
                _this.onSelectGoods(_this.list_goods[i]);
              }
            // 상품이 1개만 있을 경우
            } else if (cnt_list == 1) {
              _this.onSelectGoods(_this.list_goods[0]);
            }
          } else {
            _this.$f7.dialog.alert('이용가능한 상품이 없습니다.', '판매관리');
          }

          _this.$f7.dialog.close();

        } else {
          _this.$f7.dialog.close();
          _this.$f7.dialog.alert(response.data.msg, '판매관리');
        }
      })
      .catch(function(error) {
        console.log(error);
        _this.$f7.dialog.close();
        _this.$f7.dialog.alert('이용가능 상품정보를 가져오는 중 오류가 발생했습니다.<br>' + error, '판매관리');
      });
    },

    /**
     * 상품선택
     */
    onSelectGoods(goods) {
      // 동일 상품이 추가되어 있는지 확인
      var is_exist = false;
      for (var i = 0; i < this.list_order.length; i++) {
        if (this.list_order[i].goods_id == goods.goods_id) {
          is_exist = true;
          break;
        }
      }

      if (is_exist) {
        this.$f7.dialog.alert('이미 이용상품 목록에 포함되어 있습니다.', '판매관리');
        return;
      }

      var adult_amount = this.current_user.cnt_adult * goods.adult_price;
      var youth_amount = this.current_user.cnt_youth * goods.youth_price;
      var child_amount = this.current_user.cnt_child * goods.child_price;
      var goods_amount = adult_amount + youth_amount + child_amount;

      this.list_order.push({
        goods_id    : goods.goods_id,
        goods_name  : goods.goods_name,
        cnt_adult   : this.current_user.cnt_adult,
        cnt_youth   : this.current_user.cnt_youth,
        cnt_child   : this.current_user.cnt_child,
        adult_price : goods.adult_price,
        youth_price : goods.youth_price,
        child_price : goods.child_price,
        adult_amount: adult_amount,
        youth_amount: youth_amount,
        child_amount: child_amount,
        goods_amount: goods_amount
      });

      // 결제금액 계산
      this.computePaymentAmount();
      this.$f7.sheet.get('#popup_list_goods').close();
    },

    /**
     * 인원 변경
     */
    onChangePeople(index, type) {
      var people = Number(event.target.value);

      if (type == 'adult') {
        this.list_order[index].cnt_adult = people;
      } else if (type == 'youth') {
        this.list_order[index].cnt_youth = people;
      } else if (type == 'child') {
        this.list_order[index].cnt_child = people;
      }

      // 상품금액 계산
      var adult_amount = this.list_order[index].cnt_adult * this.list_order[index].adult_price;
      var youth_amount = this.list_order[index].cnt_youth * this.list_order[index].youth_price;
      var child_amount = this.list_order[index].cnt_child * this.list_order[index].child_price;
      var goods_amount = adult_amount + youth_amount + child_amount;

      this.list_order[index].adult_amount = adult_amount;
      this.list_order[index].youth_amount = youth_amount;
      this.list_order[index].child_amount = child_amount;
      this.list_order[index].goods_amount = goods_amount;

      // 총 인원이 0명 일 경우 해당 주문상품 삭제
      if (this.list_order[index].cnt_adult <= 0  &&  this.list_order[index].cnt_youth <= 0  &&  this.list_order[index].cnt_child <= 0) {
        this.$delete(this.list_order, index);
      }

      // 결제금액 계산
      this.computePaymentAmount();
    },

    /**
     * 주문상품삭제
     */
    deleteOrderGoods(index) {
      this.$f7.swipeout.close( this.$$('li.swipeout').eq(index) );
      this.$delete(this.list_order, index);

      // 결제금액 계산
      this.computePaymentAmount();
    },

    /**
     * 결제금액 계산
     */
    computePaymentAmount() {
      this.payment_amount = 0;
      for (var i = 0; i < this.list_order.length; i++) {
        this.payment_amount += this.list_order[i].goods_amount;
      }
    },

    /**
     * 결제하기
     */
    doPayment() {
      if (this.in_progress) {
        return;
      }

      if (this.list_order.length <= 0) {
        this.$f7.dialog.alert('이용상품을 선택해 주세요.', '판매관리');
        return;
      }

      this.in_progress = true;
      this.$$('#btn_payment').attr('disabled', true);
      this.$f7.dialog.preloader('잠시만 기다려주세요.<br>');

      // 승인요청 상품정보
      var formdata = new FormData();
      formdata.set('tourist_id', localStorage.tourist_id);
      formdata.set('a_id', localStorage.admin_id);
      formdata.set('barcode', this.current_user.barcode);
      formdata.set('package_id', this.current_user.package_id);
      formdata.set('payment_amount', this.payment_amount);

      for (var i = 0; i < this.list_order.length; i++) {
        formdata.append('goods_id[]', this.list_order[i].goods_id);
        formdata.append('cnt_adult[]', this.list_order[i].cnt_adult);
        formdata.append('cnt_youth[]', this.list_order[i].cnt_youth);
        formdata.append('cnt_child[]', this.list_order[i].cnt_child);
      }

      // 승인요청
      var _this = this;
      _this.$http.post(_this.$api_base_uri + '/ticket_auth', formdata, {
        timeout: 30000
      })
      .then(function(response) {
        console.log(response);
        _this.in_progress = false;
        _this.$$('#btn_payment').attr('disabled', false);
        _this.$f7.dialog.close();

        // 승인성공
        if (response.data.result) {
          _this.$f7.dialog.alert(response.data.msg, '판매관리');

          // 이용승인 화면 닫기
          _this.$f7.popup.get('#popup_order_goods').close();

          // 승인성공 메시지 3초 후 자동 닫기
          setTimeout(function() {
            _this.$f7.dialog.close();
          }, 1500);

        // 승인오류
        } else {
          _this.$f7.dialog.alert(response.data.msg, '판매관리');
        }
      })
      .catch(function(error) {
        console.log(error);
        _this.in_progress = false;
        _this.$f7.dialog.close();
        _this.$f7.dialog.alert('승인처리 중 오류가 발생했습니다.<br>' + error, '판매관리');
      });
    },

    /**
     * 바코드 스캔
     */
    scanBarcode() {
      console.log('scan barcode');
    },

  }
}



// WEBPACK FOOTER //
// ./src/js/sales.js